import * as React from "react"
import { Paper, ProductItem, Price, Picture } from "components"
import { Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import classnames from "classnames"
import "./sale.scss"

interface Sale {
	products: ProductItem[]
}

function useSale(total: number) {
	const [selected, setSelected] = React.useState(0)

	React.useEffect(() => {
		let onScreen = true
		const intervalId = setInterval(
			() =>
				onScreen &&
				setSelected((current) =>
					current === total - 1 ? 0 : current + 1
				),
			4000
		)
		return () => {
			onScreen = false
			clearInterval(intervalId)
		}
	}, [])

	return [selected, setSelected] as const
}

const Sale: React.FC<Sale> = ({ products }) => {
	const [selected, setSelected] = useSale(products.length)
	return (
		<Paper>
			<Row>
				<ul className="sale__list">
					{products.map((product, index) => (
						<li key={product.item_id}>
							<button
								className={classnames("sale__list__item", {
									"sale__list--active": index == selected,
								})}
								onClick={() => setSelected(index)}
							>
								<p>{product.item_name}</p>
							</button>
						</li>
					))}
				</ul>
				<Col>
					<Details {...products[selected]} />
				</Col>
			</Row>
		</Paper>
	)
}

const Details: React.FC<ProductItem> = ({
	old_price,
	image,
	item_name,
	group_name,
	item_id,
	price,
	url,
	id,
}) => {
	const licenseQty = item_name.split(group_name).join("")
	return (
		<Link
			to={{
				pathname: `/product/NAP-${id}/${url}`,
				state: item_id,
			}}
		>
			<div className="sale__product">
				<h1 data-content={licenseQty ? `لایسنس ${licenseQty}` : ""}>
					{group_name}
				</h1>
				<Picture src={image} className="sale__image" />
				<Price
					symbool
					discountSymbool
					className="sale__price"
					discount={old_price}
				>
					{price}
				</Price>
			</div>
		</Link>
	)
}

export default Sale
